import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogContent, DialogFooter, Typography } from '@pocketlaw/tetris';
import { DuplicateDialogHeader } from '../DuplicateDialogHeader';
export function NotSupportedDialog(props) {
    const { documentName, onClose } = props;
    return (<Dialog size="sm" onClose={onClose}>
      <DuplicateDialogHeader testId="duplicate-not-supported" title={t({
            message: 'Copying not possible',
            comment: 'copy document type not possible dialog title',
        })}/>
      <DialogContent>
        <Typography>
          <Trans comment="Duplicate document dialog - The document is not supported">
            It is not possible to create a copy of <b>{documentName}</b>.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button size="small" type="button" appearance="secondary" onClick={onClose}>
          <Trans>Close</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
